var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCopy = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M15,12.5h11.3c1.4,0,2.5,1.1,2.5,2.5v11.3c0,1.4-1.1,2.5-2.5,2.5H15c-1.4,0-2.5-1.1-2.5-2.5V15\n\t\tC12.5,13.6,13.6,12.5,15,12.5z" }),
            React.createElement("path", { d: "M7.5,20H6.3c-1.4,0-2.5-1.1-2.5-2.5V6.3c0-1.4,1.1-2.5,2.5-2.5h11.3c1.4,0,2.5,1.1,2.5,2.5v1.3" }))));
});
export default IconCopy;
//# sourceMappingURL=IconCopy.js.map